import { FC, useEffect, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Container, Center, Spinner } from "@chakra-ui/react";
import AOS from "aos";

import "./App.scss";
import "aos/dist/aos.css";

import { Navbar } from "shared/navbar/Navbar";
import { Footer } from "shared/footer/Footer";

import { Landing } from "pages/landing/Landing";
import { About } from "pages/about/About";
import { Media } from "pages/about/media/Media";
import Services from "pages/services/Services";
import { Skills } from "pages/about/skills/Skills";
import { Contact } from "pages/services/Contact";
import { FeaturedWork } from "pages/featured-work/FeaturedWork";
import { ProfessionalSummary } from "pages/professional-summary/ProfessionaSummary";
import { AnalyticsService} from "pages/services/Services-AnalyticsConsulting"
import WorkshopService from "pages/services/Services-Workshops";
import BuildingOrgService from "pages/services/Services-BuildingOrgs";
import TechAdviceService from "pages/services/Services-TechnicalAdvice";
import Resume from "pages/resume/Resume";

const Loader: FC = () => (
  <Center w="100%" h="100%">
    <Spinner size="lg" color="primary.500" />
  </Center>
);

export const App: FC = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Container h="100%" px={{ base: 6, md: 6, lg: 4 }}>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/media" element={<Media />} />
            <Route path="/about" element={<About />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/work" element={<FeaturedWork />} />
            <Route path="/summary" element={<ProfessionalSummary />} />
            <Route path="/analytics" element={<AnalyticsService />} />
            <Route path="/workshops" element={<WorkshopService />} />
            <Route path="/orgs" element={<BuildingOrgService />} />
            <Route path="/techadvice"  element={<TechAdviceService />} />
            <Route path="/resume"  element={<Resume />} />

          </Routes>
          <Footer />
        </Container>
      </Suspense>
    </Router>
  );
};
